import {MakeStore, StoreObject} from "../../../stem-core/src/state/Store";
import {field} from "../misc/StoreField";
import {apiClient} from "../../connection/BlinkApiConnection";


class MerchantSDKSettings extends StoreObject {
    @field("Merchant") merchant;
    @field(Object) initDefaultOptions; // TODO JSON
    @field(Object) defaultPgOptions;
}

export const MerchantSDKSettingsStore = MakeStore("MerchantSDKSettings", MerchantSDKSettings);

export async function apiUpdateMerchantSDKSettings(data) {
    return apiClient.post("merchant/update_sdk_settings/", data);
}
